function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React from 'react';
import PropTypes from 'prop-types';
import Popup from '../Popup';
class PopupButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.toggleContent = this.toggleContent.bind(this);
  }
  toggleContent() {
    const {
      isOpen
    } = this.state;
    this.setState({
      isOpen: !isOpen
    });
  }
  render() {
    const {
      isOpen
    } = this.state;
    const _this$props = this.props,
      {
        children,
        trigger,
        width
      } = _this$props,
      props = _objectWithoutProperties(_this$props, ["children", "trigger", "width"]);
    const payload = _objectSpread({}, this.state, {
      toggleContent: this.toggleContent
    });
    return React.createElement(React.Fragment, null, trigger(payload), React.createElement(Popup, _extends({}, props, {
      isOpen: isOpen,
      onRequestClose: this.toggleContent,
      width: width
    }), children(payload)));
  }
}
_defineProperty(PopupButton, "propTypes", {
  children: PropTypes.func.isRequired,
  trigger: PropTypes.func.isRequired,
  width: PropTypes.string,
  // for popup
  isOpen: PropTypes.bool.isRequired,
  isCentered: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  onRequestClose: PropTypes.func,
  onClose: PropTypes.func,
  theme: PropTypes.shape({}).isRequired,
  hideOnBackdropClick: PropTypes.bool,
  className: PropTypes.string,
  zIndex: PropTypes.number
});
_defineProperty(PopupButton, "defaultProps", {
  width: '650px'
});
export default PopupButton;